<template>
    <div class="courseList">

        <div class="paddingH16">
            <div class="color101010" style="padding: 16px 0 13px;">
                我的团队成员明细
            </div>

            <div class="filterArea">
                <div style="padding: 10px; border: solid 1px #B8BCC5;">

                    <i class="icon clockIcon size24"></i>

                    <el-date-picker class="alignC noBorder noBg" style="width: 100px;" type="date"
                        v-model="startTime" placeholder="开始" @change="onChangeStartTime"/>
                    至
                    <el-date-picker class="alignC noBorder noBg" style="width: 100px;" type="date"
                        v-model="endTime" placeholder="结束" @change="onChangeEndTime"/>
                </div>

                <div class="flexLayout font14r marginT16" style="line-height: 34px;">
                    <div class="alignC color101010" style="width: 90px;">
                        排序条件：
                    </div>
                    <div class="flexItem">
                        <select class="selectbox color101010">
                            <option value="">成交数</option>
                        </select>
                    </div>
                </div>

                <div class="flexLayout font14r marginT12" style="line-height: 34px;">
                    <div class="alignC color101010" style="width: 90px;">
                        分销成员：
                    </div>
                    <div class="flexItem">
                        <input type="text" class="inputbox" placeholder="请输入分销成员姓名"
                            v-model="filters.userName"/>
                    </div>
                </div>

                <div class="marginT12">
                    <button class="block w100p noBorder roundBorder4" style="background: #F2C056; color: white;
                        height: 39px; line-height: 39px;" @click="reloadDataList()">查询</button>
                </div>

            </div>
        </div>

        <div class="marginT24">
            <div class="list" style="border: solid 8px #F2C056; border-bottom-width: 27px;">
                <div class="item white_bg" v-for="(dataItem, index) in dataList"
                     :key="dataItem.id" data-click="viewItem(dataItem)" style="border-bottom: solid 2px #F2C056;">

                    <div class="inner padding12 clearfix" style="line-height: 40px;" :data-userid="dataItem.userId">

                        <i class="icon numberIcon fl" v-if="index < 3" style="margin-right: 6px; margin-top: 10px;"></i>

                        <span class="font14r color999 floatL" v-else="">{{index + 1}}</span>

                        <div class="inlineBlock size40 imageArea circle hiddenOverflow floatL">
                            <img class="fullSpace cover" :src="dataItem.headerImg"/>
                        </div>

                        <span class="color777 font14r marginL12 floatL">{{dataItem.userName}}</span>

                        <span class="red font12r marginL16 floatL">成交数：{{dataItem.distributionCount}}</span>
                        <span class="color777 font12r floatR">占比例：{{dataItem.distributionRatio}}</span>

                    </div>

                </div>
                <div class="hand alignC font14r" style="line-height: 34px; color: #B7B6B5;"
                     v-show="pagination.current < pagination.totalPage"
                     @click="loadNextPage()">
                    点击加载更多&gt;
                </div>
            </div>
        </div>

        <div class="alignCenter colorCCC bold paddingV16" v-show="status == 'ready' && dataList.length < 1">
            <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
        </div>

    </div>
</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import appHelper from "@util/appHelper";

//
import moment from "moment";
import Vue from "vue";
import dataMixedUtils from "@util/dataMixedUtils";

const config = {
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/agency/getMemberPerformanceList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {}
        }
    }
}

export default {
    extends : generalCmpPart,
    components : {  },
    props : {
        agencyId : String
    },
    data() {
        return {
            apiConfig : config.apiConfig,

            enableDataList : true,
            // autoLoadDataList : true,

            startTime : '',
            endTime : '',

            pageSize : 5,
            filters : {
                userName : '',
                startTime : '',
                endTime : '',
            }
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.redirect('/liveTelecast/' + dataItem.id);
        },
        viewIncome() {
            this.$refs.viewInComeDrawer.open();
        },
        formatDateTime(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm');
        },
        onChangeStartTime(date) {
            if (date)
            {
                this.filters.startTime = moment(date).format('x');
            }
            else
            {
                this.filters.startTime = '';
            }
        },
        onChangeEndTime(date) {
            if (date)
            {
                this.filters.endTime = moment(date).format('x');
            }
            else
            {
                this.filters.endTime = '';
            }
        },

    },
    mounted() {
        // for (let i=0; i<this.pageSize; i++)
        // {
        //     this.dataList.push({
        //         id : i,
        //         distributeName : dataMixedUtils.string.getRandomChineseName(),
        //         distributeId : '93562984',
        //         distributeNickName : dataMixedUtils.string.getRandomNickName(),
        //         createTime : new Date().getTime(),
        //         orderCount : dataMixedUtils.number.getRandomInteger(20),
        //         orderCountRate : Math.random(),
        //     });
        // }
    },
    watch : {
        agencyId() {
            this.apiConfig.list.params.agencyId = this.agencyId;
            this.reloadDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
.red {
    color: #F42418;
}
.black101010 {
    color: #101010;
}
.grey777 {
    color: #777;
}
.courseLabel {
    height: 27px;
    line-height: 27px;
    background: transparent;
    padding: 0 8px;
    border: solid 1px #BBBBBB;
    border-radius: 4px;
    color: #101010;
}
.viewIncomeButton {
    border: solid 1px #F4950E;
    background: #F28500;
    border-radius: 8px;
    color: white;
    padding: 0 24px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
}
.filterArea {
    .selectbox, .inputbox {
        display: block;
        width: 100%;
        height: 34px;
        line-height: 34px;
        padding: 0 10px;
        box-sizing: border-box;
        border: 1px solid rgba(187, 187, 187, 100);
        background: transparent;
    }
}
.list {
    .item:nth-child(1) .numberIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAAB/ElEQVRYhe3X30tTYQDG8QMRRDdCdJd/Qf9Il5rQVaijNRFHpTEL6YeWmYfwBHqzhHWxrIjV8KK78EYvzjZ3dO606ebZOQtiUCybs1UXFt8uTheNuVCZ8wjvA8/V+/K+H17ei/eVWDjfy3x7kfk2nNX2EgsdLgnVXUK9hCMbcRclNF+J+CCOrDZYlFh50EtyvEhyHGdVLpEYc0n/BvWil4gLoh5Y7IP4NdB8sDwEibuQHAVdhpQC6SlY9UMmANkgGC8hFwJrFswwGK9g/Zk9vuqH9CS8nwD9Iazcg+VbsHQD4v2w6LX3VF2gdnqlehFAATzSQDMMGynYykM5b0MPHbgehMIcbBrwe5uqfHjrAOCPT9SNAO71DlphARRAARRAARRAARTAowQszEHZgLIJWxZUPlYDK4W/r2vTnpd92mTghs6ekpsRQAf86iKdHajdvw4P2P2NaFdbXaB9il1niHkUYn0/mwj8TsyjoPWc/i+uChq90kr8qsKS78sBAjeJ9w+juk/tGlYD1W62kBgaI3Hna+OA9yskbj9CHdg/rBY6chJ9dABd/rxvYFqx0OXraHJLw2A10PzICVITl0lPpXYNzDyxWJvsQZs+fmCwHbFr/nNkAiGywe2dgTPvyAQuQOhYU2E1UON5K8aLYXKvk1izWcw3jzFCZxux9h/FbSfqC4yXygAAAABJRU5ErkJggg==');
    }
    .item:nth-child(2) .numberIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAADKElEQVRYhe3X+0tTYRzH8QMRRL8E0W/1F/SPdKOE6EJIYNBFukhFRIFQZDfy0oWazmzm1kwtLW9lXhrTuXV0ZZMuzso5L7u4uZm3Mrfz7ofqrHJGhM0n6IHvj+fw4nyf7/N8jhSV81IVWRNQZA1CVZsmHGnLTZEUhzGsOIyIWDiKA5LirA0rzlpELJy1ASnqak7FbQkobgtiVUs44jKlSN8vWrL30ZoDtisga8CeD8908FwPnUZ4WQqvy8FZCW9qoecR9DZBnxkGW8Erg/8p+Nph0Ar9ZuhthHcPobvqy7MvS6DTAB06sGtBvgrWi2DJBPNZMGXsk2Zb/4H/gf8aUOmuZtycSbB0Fz7dJjzadfgKtxCqOsKUwzi/wCk5D3/hZjy5q2etkQfHwdWQeOBkcxaevLUqxH9zK+GqI4QqD+H7CT3WmJF44Ghd+heAdh3j5kxwm9Q9qHhshGuOqkBv/nqiXfcS3+Kx+pN8bMuPOyTKgAXfjY0qctJySbwpDt0/GGtz/UnxgCMP01XgaF26eMDhe2kqcNx0Xiyg4rHhvb5BBX56bhALOCFrVdyQfhu8FeiqUzw2/EXbYu01Z4l1F79vOBX7eoZklJ56cYAfOvR4ctd8Ba5hqsMgTpqZ7qrEW5AUO1oaM+Y/zXwDRrqr8d/couKGK/bDgEUMYNRZxZA+ObbvincQ7W8WIw9GXpUzpI9N7NCt7UT7msUIrJHO2/iLtn533iUTdTWJkainn97Ap4ulFU/uakIVaYQqDzNccYDg3b0E76QSLNtDsHQ3wZKdTJjOJQ4YvL3jl0k6Xo0+OJY4YKA4RWzg/P3VWbI2YrkYmUfgGI9PJ80KlCRJwpqzHNvlbGTNh4QBbZcmaMnMxpS17Je4H6BPrq/AXpDNM13wrwHbtSPI105gzVn627AZULt2CQ7DGTqNoTkEjtNReAFrwZ/D4kAX86r0EF0V/j8GdpX38LrkMHbtkjmDzYC6TItwVu/kbc2L3wfW9dBdsxu7feFfg8XHNqzC3VRGv3k6LnDAXI+7aTOULUgobAZ0wLSCwdYTeGUHfrsTX3sO3icr5+LdnwEZcWxBjUIarAAAAABJRU5ErkJggg==');
    }
    .item:nth-child(3) .numberIcon {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAADfElEQVRYhe3XW2/aZhgHcEvTpGk3labdrZ9gX2SXkybtvhfTVKlX2xfoRdukS5RuvUgTFtqunZpzs1DCwcYEwsE42BxsMLYx2BAIlFACU05L0/a/q7khTaJqSxxP6l96rixZP71+n/fxS7go/uoixbUXSQ62KorrPqNSV4hATOwGoiLsWHRUaBNMqthlUkXYsRLpYpvISsZVQVlrC3IVtiql2s1IxhXicNyh/DVPWIIvooCKFxFkywhzFURSa4hn18HmnoMrbCCtdpDVesjpWyhUd6DW/4LWOIDeeg299QZa4yWU2h7yxjaEUg8ppYOk1AIjNBBN1xBKGqATJZAxFZ6whGdBEQtkBnNeDlMe9hpxUj4APwD/b8Cs1oN7RYNjhsXw/SAGxkncfRyBcz4Jkqkgp29dHNAf1zF8P4gbo74T65dHK4gLTeuBVMLogwxN0HjkSmPKl8O9Kabv2Z2HIXCFtrXAlNKBc24Vt8b8WFxWIa/t9u1Bf6LSh3SFFOs/cUrZRCTdOLFJxg6t5MM/ePt18ZOlrAl0ziftB3TMsCZw0iPYCxgXWrh5z28Cw3zNHsC8sQNPtIzbvwZM3LRXvPhJcvdxpA91Y9SHnyZouEKqPUbdwDj5ziH9uzuDRG7DHsA5UsKkR8TEXBK3HW9X8uaoD/OUdPHAw01Sar4CyVQwOE6Z0Kd0wT7Af44ZerVqAgcdFBihaS+gVNnpO2pIRrcXUKntYchJm8DFoGztz0KArZ4KTBd7fV3tjWrWAZ8GJHOE5fStd4BqfR/O+aSJGxgjwYgW7cGE2MSg422HDjuDmPXnQSdrWMk0sRQp4+ffwn2rN+21eBYH2Erf/jqtHixw4OUX1h8zvNzBjD+HkQehY2GjT2JY5ur2mCS8somY0EKIX0dMaCFb+vN8bnVLy7lvlsKFVxd37eS3pj3s1ycCCYIggoz6hS8ijwTixT2rgC5a2Fnwp0cm3fznp+IOx8tql5dX9ZEwV31xjsCeJyRfn/VLn7037GgCfPlSLFO/Fc+ub54hcJtmS0N+5j/AjsbNNz5dzT//gZc3Wv8WmBCbejRd/zHAly+dGexoDAOfZNTOd1mtm39fYFrd1Dm5/T3P4+Nzgx0X2dj+Sq7tzqr1/YPjgJKxTYla71sAH1kKOxqtvntZax5c11uvBX3jjao1Xt7RqvtfnsW7/wboVVUVZ96+OgAAAABJRU5ErkJggg==');
    }
}
</style>
